import { render, staticRenderFns } from "./RentToOwnTip.vue?vue&type=template&id=3ad3fff5"
import script from "./RentToOwnTip.vue?vue&type=script&lang=js"
export * from "./RentToOwnTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports